import axios from '@fs/zion-axios'

const BASE_CHAT_PATH = '/service/dmc/chat'

export function getChatMessage(messageId) {
  return axios.get(`${BASE_CHAT_PATH}/messages/${messageId}`)
}

export function getUserChatMessages(cisId, limit, offset, next, previous) {
  const params = {
    limit,
    offset,
    next,
    previous,
  }
  return axios.get(`${BASE_CHAT_PATH}/users/${cisId}/messages`, { params })
}

export function getChannelChatMessages(
  channelId,
  limit,
  retrieveFromMessageId,
  messageLogicOperatorString,
  getAllMessagesOverride = false
) {
  const params = {
    limit,
    retrieveFromMessageId,
    messageLogicOperatorString,
    getAllMessagesOverride,
  }
  return axios.get(`${BASE_CHAT_PATH}/channels/${channelId}/messages`, { params })
}

export function getAttachedImage(imageSource) {
  return axios.get(imageSource, { responseType: 'blob' })
}

export function getChannelMembers(channelIds) {
  return axios.post(`${BASE_CHAT_PATH}/channels/members`, channelIds)
}

export function getReplyChatMessages(channelId, limit) {
  const params = {
    limit,
  }
  return axios.get(`${BASE_CHAT_PATH}/channels/${channelId}/replymessages`, { params })
}

export function redactMessage(messageRedactPayload) {
  return axios.post(`${BASE_CHAT_PATH}/messages/redact`, messageRedactPayload)
}

export function redactAllUserMessages(cisId) {
  return axios.post(`${BASE_CHAT_PATH}/users/${cisId}/messages/redactAll`)
}

export function getMessageAttachmentInfo(filename) {
  const params = {
    filename,
  }
  return axios.get(`${BASE_CHAT_PATH}/attachment/info`, { params })
}

export function getStreamQueueStatus() {
  return axios.get(`/service/fs-chat/api/v2/moderation/review_queue/users/status`)
}
